import { action, makeObservable, observable } from 'mobx';

import ApiService from '../services/ApiService';

import { InvoiceType } from './models/InvoiceType';
import { Loadable } from './models/Loadable';
import { ISsoStore } from './SsoStore';
import { ITranslateStore } from './TranslateStore';

export interface IReferenceNumberStore {
  readonly masterReferenceNumber: Loadable<string>;

  tryLoadMasterReferenceNumber(): void;

  refNumberName(invoiceType: InvoiceType, assignedName: string): string;
}

export default class ReferenceNumberStore implements IReferenceNumberStore {
  @observable
  public masterReferenceNumber: Loadable<string> = new Loadable<string>();

  constructor(
    private apiService: ApiService,
    private ssoStore: ISsoStore,
    private translateStore: ITranslateStore
  ) {
    makeObservable(this);
  }

  @action.bound
  public tryLoadMasterReferenceNumber(): void {
    if (!this.masterReferenceNumber.isInitial) {
      return;
    }
    const masterReferencePromise = this.apiService.getMasterRefNumber(this.ssoStore.customer.customerId);
    this.masterReferenceNumber = Loadable.toLoadable(masterReferencePromise);
  }

  public refNumberName(invoiceType: InvoiceType, assignedName: string): string {
    if (invoiceType === InvoiceType.MOBILE) {
      return this.defaultInvoiceName(invoiceType);
    }
    if (assignedName != null) {
      return assignedName;
    }
    return this.defaultInvoiceName(invoiceType);
  }

  public defaultInvoiceName(invoiceType: InvoiceType): string {
    const translate = this.translateStore.translate;
    switch (invoiceType) {
      case InvoiceType.MOBILE:
        return translate('shared.invoices.invoice-name.mobile-service');
      case InvoiceType.GOODS:
        return translate('shared.invoices.invoice-name.product');
      case InvoiceType.STATE_FEES:
        return translate('shared.invoices.invoice-name.state-fees');
      case InvoiceType.FINANCE:
        return translate('shared.invoices.invoice-name.finance');
      case InvoiceType.DEBT:
        return translate('shared.invoices.invoice-name.debt');
      case InvoiceType.TELESERVICES:
        return translate('shared.invoices.invoice-name.teleservices');
      case InvoiceType.PENALTY:
        return translate('shared.invoices.invoice-name.penalty');
      default:
        return translate('shared.invoices.invoice-name.other');
    }
  }
}
